<template>
  <div class="site-footer-shell">
    <home-footer @license="openLicense" />
  </div>
</template>

<script>
import HomeFooter from './HomeFooter.vue'

export default {
  name: 'SiteFooter',
  components: { HomeFooter },
  methods: {
    openLicense () {
      const base = (process.env.VUE_APP_INDEX || 'https://wesitrans.com').replace(/\/$/, '')
      this.$track('footer_navigation', {target: 'license'})
      window.location.assign(`${base}/license`)
    }
  }
}
</script>

<style scoped>
.site-footer-shell{flex:0 0 auto;margin-top:auto}
@media(max-width:768px){.site-footer-shell{padding-bottom:calc(var(--mobile-bottom-height,58px) + env(safe-area-inset-bottom));background:#19192b}}
</style>
